import * as React from "react";
import { forwardRef } from "react";
const SvgDottedLine = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 23, viewBox: "0 0 104 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("line", { x1: 3.5, y1: 3.5, x2: 100.5, y2: 3.5, stroke: "black", strokeWidth: 7, strokeLinecap: "round", strokeDasharray: "0.1 15" }));
const ForwardRef = forwardRef(SvgDottedLine);
export default ForwardRef;
